import React, { useEffect, useRef, useState } from 'react'
import { useTheme } from '@mui/material'
import hipersendService from '../../services/hipersend'
import MedidorDeSaldo from '../shared/disparo/MedidorDeSaldo'
import { tokensDoDisparo } from '../shared/disparo/tokens'
import { linkDeRecargaSeguro } from '../../libs/suspensaoOficial'
import { reais, numero } from '../../libs/disparos'
import '../shared/disparo/disparo.css'

// Bloco de impacto do "Reenviar com erro": quantas mensagens voltam para a
// fila no período escolhido, quanto podem custar e se o saldo cobre — pela
// mesma conferência que o servidor aplica no reenvio. Avisa quem usa por
// `onVeredito({ bloqueado })`: sem saldo (bloqueio ativo) ou sem nada para
// reenviar, o PROSSEGUIR não faz sentido.

export default function ImpactoDoReenvio({ api, secret, lastHours, linkRecarga, onVeredito }) {
  const theme = useTheme()
  const [conferencia, setConferencia] = useState(null)
  const [carregando, setCarregando] = useState(true)
  const [erro, setErro] = useState('')
  const avisar = useRef(onVeredito)
  avisar.current = onVeredito

  useEffect(() => {
    if (!api || !secret) return undefined
    let vivo = true
    setCarregando(true)
    setErro('')
    hipersendService.notificacoesInteligentes
      .conferirReenvio(api, secret, lastHours)
      .then((c) => {
        if (!vivo) return
        setConferencia(c)
        const nada = c?.reenviaveis === 0
        if (avisar.current) avisar.current({ bloqueado: c?.veredito === 'saldo_insuficiente' || nada })
      })
      .catch(() => {
        if (!vivo) return
        // Sem conferência o reenvio segue, como no servidor: cada mensagem
        // continua passando pelo bloqueio por saldo do envio.
        setConferencia(null)
        setErro('Não foi possível estimar o custo agora. O reenvio continua conferindo o saldo mensagem a mensagem.')
        if (avisar.current) avisar.current({ bloqueado: false })
      })
      .finally(() => { if (vivo) setCarregando(false) })
    return () => { vivo = false }
  }, [api, secret, lastHours])

  const c = conferencia
  const insuficiente = c?.veredito === 'saldo_insuficiente'
  const link = linkDeRecargaSeguro(linkRecarga)
  const avisos = (c?.motivos || []).filter((m) => m.tipo === 'aviso')

  return (
    <div className="dp" style={{ ...tokensDoDisparo(theme), marginTop: 12 }}>
      <div className="dp-impacto" aria-busy={carregando}>
        {carregando && !c ? (
          <span className="dp-extra">Conferindo quantas voltam e quanto custam…</span>
        ) : c?.reenviaveis === 0 ? (
          <span className="dp-extra">Nenhuma mensagem com erro para reenviar nesse período.</span>
        ) : (
          <>
            {c?.reenviaveis != null && (
              <div className="dp-grande">
                <strong>{numero(c.reenviaveis)}</strong>
                <span>{c.reenviaveis === 1 ? 'mensagem volta para a fila' : 'mensagens voltam para a fila'}</span>
              </div>
            )}
            {c?.custo?.cobravel && (
              <div className="dp-lin"><span>Custo</span><b>até {reais(c.custo.total)}</b></div>
            )}
            {c?.custo && !c.custo.cobravel && (
              <div className="dp-lin"><span>Custo</span><b>sem custo no saldo</b></div>
            )}
            {c?.saldo && c?.custo?.cobravel && (
              <MedidorDeSaldo
                atual={c.saldo.atual}
                comprometido={c.saldo.comprometido}
                total={c.custo.total}
                tolerancia={c.saldo.tolerancia}
                rotuloDoEnvio="Este reenvio"
              />
            )}
            {insuficiente && (
              <div className="dp-selo bad" role="alert">
                <span className="ic">!</span>
                <div>
                  <b>O saldo não cobre este reenvio</b>
                  <span>Recarregue e volte aqui para reenviar.</span>
                </div>
              </div>
            )}
            {insuficiente && link && (
              <a className="dp-btn pri inicio" href={link} target="_blank" rel="noopener noreferrer">Recarregar saldo</a>
            )}
            {avisos.length > 0 && (
              <ul className="dp-avisos">{avisos.map((m) => <li key={m.codigo}>{m.texto}</li>)}</ul>
            )}
            {erro && <span className="dp-extra">{erro}</span>}
          </>
        )}
      </div>
    </div>
  )
}
